import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './directives.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import {quillEditor, Quill} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// 设置字体大小
const fontSizeStyle = Quill.import('attributors/style/size') // 引入这个后会把样式写在style上
fontSizeStyle.whitelist = ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px', '36px']
Quill.register(fontSizeStyle, true)
// 设置字体样式
const Font = Quill.import('attributors/style/font') // 引入这个后会把样式写在style上
const fonts = [
  'SimSun',
  'SimHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong'
]
Font.whitelist = fonts // 将字体加入到白名单
Quill.register(Font, true)
Vue.component('quill-editor', quillEditor)

import Axios from "axios";

Vue.prototype.$axios = Axios
Vue.config.productionTip = false
import global from "@/views/global";

Vue.prototype.GLOBAL = global;
/**********************************axios拦截器添加token*******************************/
Axios.interceptors.request.use(config => {
  if (localStorage.token) { //判断token是否存在
    config.headers.token = localStorage.token;  //将token设置成请求头
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
/**************************************Date转YYMMDD*******************************/
Vue.prototype.dateFormatMonthYYYYMM = function (date) {
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + '';
  return Y + M + D;
};
/********************深拷贝,适用于对象，数组，时间，函数等类型*****************************/
Vue.prototype.deepClone = function (obj, hash = new WeakMap()) {
  //如果是null 或者undefined 我就不进行拷贝操作
  if (obj == null) return obj;
  if (obj instanceof Date) return new Date(obj);
  if (obj instanceof RegExp) return new RegExp(obj);
  //可能是对象 或者普通的值 如果是函数的话，是不需要深拷贝的  因为函数是用来调用的，不需要再拷贝一个新的函数
  if (typeof obj !== 'object') return obj;
  // 是对象的话就要进行深拷贝 [] {} Object.prototype.toString.call(obj)==[object Array]?[]:{}
  if (hash.get(obj)) return hash.get(obj);
  let cloneObj = new obj.constructor;
  hash.set(obj, cloneObj);
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      //实现一个递归拷贝
      cloneObj[key] = this.deepClone(obj[key], hash);
    }
  }
  return cloneObj;
};
/*******************************支持unicode的cookie读取、写入器***********************/
Vue.prototype.deemo = {name: 'value'}
Vue.prototype.docCookies = {
  getItem: function (sKey) {
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  },
  setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function (sKey, sPath, sDomain) {
    if (!sKey || !this.hasItem(sKey)) {
      return false;
    }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function (sKey) {
    return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
  },
  keys: /* optional method: you can safely remove it! */ function () {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nIdx = 0; nIdx < aKeys.length; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }
    return aKeys;
  }
};
/*********************************文件路径获取***************************************/
Vue.prototype.getFileUrl = function (path) {
  if (typeof path != 'undefined' && path != null && path !== '') {
    return this.GLOBAL.EXPORTURL + path.substring(3, path.length);
  } else {
    return '';
  }
};
/*********************************浏览文件*****************************************/
Vue.prototype.onPreviewFile = function (file) {
  if (file.status == 'success') {
    window.open(file.url, "_blank");
  }
};
/******************************文件删除前确认****************************************/
Vue.prototype.onBeforeRemoveFile = function (file, fileList) {
  if (file.status == 'success') {
    return this.$confirm(`确定移除 ${file.name}？`);
  }
};
/********************************返回消息提示****************************************/
Vue.prototype.showSuccessMsg = function (msg) {
  this.$message({
    message: msg,
    type: 'success'
  });
};
Vue.prototype.showFailMsg = function (msg) {
  this.$message.error(msg);
};
Vue.prototype.showNotifyError = function(msg) {
  this.$notify.error({
    title: '错误',
    message: msg,
    duration: 4500,
    offset: 100
  });
};

/***********************date类型转“yy-mm-dd hh:mm:ss*******************************/
Vue.prototype.dateFormatyyyymmddhhmmsswithLine = function(val){
  let date =  new Date(val);
  let Y = 1900+date.getYear()+ '-';
  let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  let D = date.getDate()< 10 ? '0' + date.getDate() : date.getDate() + '';
  let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  let ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  return Y+M+D + ' ' + hh + mm + ss;
};
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

/************************输入限制数字、小数点、小数点位数***********************************/
//用法示例：@input="(val)=>{formAdd.centrestake = limitDecimalInputWithDigit(val, 3)}"
Vue.prototype.limitDecimalInputWithDigit = function(value, digit){
  // 先把非数字的都替换掉(空)，除了数字和.
  value = value.replace(/[^\d.]/g, "");
  // 必须保证第一个为数字而不是.
  value = value.replace(/^\./g, "");
  // 保证只有出现一个.而没有多个.
  value = value.replace(/\.{2,}/g, ".");
  // 保证.只出现一次，而不能出现两次以上
  value = value
    .replace(".", "$#$")
    .replace(/\./g, "")
    .replace("$#$", ".");
  // 限制几位小数
  let subscript = -1;
  for (let i in value) {
    if (value[i] === ".") {
      subscript = i;
    }
    if (subscript !== -1) {
      if (i - subscript > digit) {
        value = value.substring(0, value.length - 1);
      }
    }
  }
  return value;
};
/****************************全局遮罩***********************************/
//this.openLoading('数据加载中', '服务超时', 'dialog***', 5*60*1000)
Vue.prototype.openLoading = function(waittext, timeouttext, time){
  this.GLOBAL.lodingInstance = this.$loading({
    // target:document.getElementById(divId),
    lock: true,
    text:waittext,
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  this.GLOBAL.loadingState = true;
  this.GLOBAL.loadingSetTimeout = setTimeout(() => {
    if (this.GLOBAL.loadingState){
      this.showFailMsg(timeouttext);
      this.closeLoading();
    }
  }, time);
};
Vue.prototype.closeLoading = function(text, time){
  if (typeof this.GLOBAL.lodingInstance != 'undefined' && this.GLOBAL.lodingInstance != null){
    this.GLOBAL.lodingInstance.close();
    this.GLOBAL.loadingState = false;
    clearTimeout(this.GLOBAL.loadingSetTimeout)
  }
};




// WEBPACK FOOTER //
// ./src/main.js